import type { IUseGetSocialOfferPrescriptionFilledResponse } from "@api";
import { Popover } from "@mui/material";
import { Stack, Typography } from "@mui/material";
import { useI18nContext } from "@root/utils/organisation";
import type { IPopoverState } from ".";

export const AccompaniementPopover = ({
  anchorEl,
  setAccompaniementPopoverState,
  otherIntegratedSocialOffers,
  accompaniement,
}: {
  accompaniement: string;
  anchorEl: HTMLElement | null;
  otherIntegratedSocialOffers: IUseGetSocialOfferPrescriptionFilledResponse["otherIntegratedSocialOffers"];
  setAccompaniementPopoverState: (state: IPopoverState) => void;
}) => {
  const { timeZone } = useI18nContext();
  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={() =>
        setAccompaniementPopoverState({ anchorEl: null, otherIntegratedSocialOffers: [], accompaniement: "" })
      }
    >
      <Stack sx={{ padding: 2 }}>
        <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
          <Typography variant="body1SemiBold">Structure d'accompagnement :&nbsp;</Typography>
          <Typography variant="body1">{accompaniement}</Typography>
        </Stack>
        <Typography variant="body1SemiBold">
          Autres services intégrés par le candidat:
          {otherIntegratedSocialOffers.map((offer) => (
            <Typography
              variant="body1"
              key={offer.name}
              sx={{ paddingLeft: 2, "&:before": { content: '"\u2022"', marginRight: 1 } }}
            >
              {offer.name} (intégré le {offer.integrationDate.toLocaleDateString("fr-FR", { timeZone })})
            </Typography>
          ))}
        </Typography>
      </Stack>
    </Popover>
  );
};
